import React from 'react'

interface HeaderProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <div className="main-header">
      <div className="main-header-left">
        <h1 className="main-title">{title}</h1>
        {subtitle && (
          <span className="studio-subtitle" style={{ display: subtitle ? 'inline-block' : 'none' }}>
            {subtitle}
          </span>
        )}
      </div>
      {actions && <div>{actions}</div>}
    </div>
  )
}
